/*jshint globalstrict: false*/

import Vue from 'vue';
import CoffeeSamplerListHome from '../components/home/coffee-sampler-list-home';
import axios from 'axios';

Vue.component('coffee-sampler-list-home', CoffeeSamplerListHome);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="coffee-sampler-list-home-vue"]',
    });
});
